import React, { useState, useEffect } from "react";
import { Col, Container, Row, Card, CardBody } from "reactstrap";
import { Button, Form } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import axios, { post, get, patch } from "axios";
import { ToastContainer, toast } from "react-toastify";
import config from "../../../../config";
import Loader from "../../../Helper/Loader";
import empty from "is-empty";
import Select from "react-select";
import Breadcrumbs from "../../../Helper/Breadcrumbs";

const PostForm = (props) => {
  let history = useHistory();
  let tokenKey = {
    Authorization: "Token " + sessionStorage.getItem("tokenKey"),
    "Content-Type": "multipart/form-data",
  };
  let propsState = props.history.location.state;
  const [form, setForm] = useState({});
  const [editMode, setEditMode] = useState(
    (propsState && propsState.editMode) || false
  );
  const [errors, setErrors] = useState({});
  const [loading, setloading] = useState(true);
  const [overlay, setoverlay] = useState(false);
  const [blogpost, setBlogPost] = useState([]);
  const [blogpostList, setBlogPostList] = useState({});
  const [city, setCity] = useState([]);
  const [cityList, setCityList] = useState({});
  const [state, setState] = useState([]);
  const [stateData, setstateData] = useState({});
  const [active, setActive] = useState(false);
  const [file, setFile] = useState();
  const [blogID, setBlogID] = useState();

  const logo = `${process.env.PUBLIC_URL}/img/images/upload.png`;

  let toastAttr = {
    theme: "colored",
    position: "top-center",
    autoClose: 1000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  };
  let breadcrumbData = [
    {
      title: "Masters",
      href: "/masters",
    },
    {
      title: "Post",
      href: "/masters/post",
    },
    {
      title: editMode ? "View" : "Create",
      href: "#",
    },
  ];
  const [tab, setTab] = useState({
    details: true,
  });
  const [tabData, setTabData] = useState([
    {
      name: "Post Details",
      id: "details",
      show: true,
    },
  ]);

  const handleInput = (keyName, value) => {
    if (keyName === "image") {
      setFile(URL.createObjectURL(value));
    }

    setForm({
      ...form,
      [keyName]: value,
    });
    if (keyName && !!errors[keyName])
      setErrors({
        ...errors,
        [keyName]: null,
      });
  };

  const renderListView = () => {
    history.push("/masters/post");
  };

  const findErrors = () => {
    const { name, description, image } = form;
    const newErrors = {};
    if (empty(name)) newErrors.name = "This is a required field";
    if (empty(description)) newErrors.description = "This is a required field";
    if (empty(image)) newErrors.image = "This is a required field";

    return newErrors;
  };
  const handleSelect = (keyName, setFn, e) => {
    // if(keyName === 'mandap'){
    //     let selmandap = mandapData.filter(obj => obj.id = e && e.value)
    //     setState(selmandap.state_name);
    // }
    setFn(e);
    setForm({
      ...form,
      [keyName]: (e && e.value) || null,
    });
    if (keyName && !!errors[keyName])
      setErrors({
        ...errors,
        [keyName]: null,
      });
  };

  const saveForm = () => {
    let id = editMode ? propsState.id : null,
      method = editMode ? "put" : "post";
    const newErrors = findErrors();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      toast.error("Enter all required details to proceed", toastAttr);
    } else {
      setLoader(true);
      let url = editMode
        ? config.service + "/masters/post/" + propsState.id + "/"
        : config.service + "/masters/post/";
      // data.area_id = form.id

      let data = new FormData();
      data.append("name", form.name);
      data.append("description", form.description);
      data.append("link", form.link);
      if (file) data.append("image", form.image);
      // data.append('image',form.image)
      if (form.blog_id) {
        data.append("blog_id", form.blog_id);
      } else {
        data.append("blog_id", blogID);
      }

      axios({
        url: url,
        method: method,
        headers: tokenKey,
        data: data,
      })
        .then((res) => {
          if (editMode) toast.success("Saved successfully", toastAttr);
          setTimeout(renderListView(), 5000);
          setLoader(false);
        })
        .catch((err) => {
          setLoader(false);

          if (err.response.status[0].status === 401) window.location.href = "/";
          else toast.error("Data already exists", toastAttr);
          setLoader(false);
        });
    }
  };

  const setLoader = (val) => {
    setloading(val);
    setoverlay(val);
  };

  useEffect(() => {
    get(config.service + "/masters/blogpost/", { headers: tokenKey }).then(
      (res) => {
        let blogpost = [];
        res.data[0].data.map((obj) => {
          blogpost.push({ value: obj.id, label: obj.title });
        });

        if (propsState && propsState.editMode)
          get(config.service + "/masters/post/" + propsState.id, {
            headers: tokenKey,
          }).then((resp) => {
            let blogpostVal = blogpost.filter(
              (temp) => temp.value === resp.data[0].data.blog
            );
            setBlogPost(blogpostVal);
            setForm(resp.data[0].data);
            setBlogID(resp.data[0].data.blog);
            setLoader(false);
          });
        else setLoader(false);
        setBlogPostList(blogpost);
      }
    );

    // if(propsState && propsState.editMode)
    //     get(config.service+'/masters/blogpost/'+propsState.id,{headers:tokenKey}).then(resp=>{
    //       setForm(resp.data[0]);
    //       setLoader(false);
    //     })
    //     else setLoader(false);
  }, []);

  return (
    <Container className="vendor">
      <Row>
        <Col md={12} className="contBody">
          <Card>
            <CardBody className="theme-light">
              <div className="card__title pageNav">
                <div className="bold-text">
                  <Breadcrumbs data={breadcrumbData} />
                </div>
              </div>
              <Row className="formBtnsDiv">
                <Col md={12}>
                  <Button
                    variant="primary"
                    onClick={(e) => {
                      saveForm();
                    }}
                  >
                    Save
                  </Button>
                  <Button
                    variant="secondary"
                    onClick={(e) => {
                      renderListView();
                    }}
                  >
                    Cancel
                  </Button>
                </Col>
              </Row>
              <Row className="formBtnsDiv">
                <Col md={12} style={{ margin: "5px 0" }}></Col>
              </Row>
              <Row className="formDiv">
                <Col md={12}>
                  <nav>
                    <div className="nav nav-tabs" id="nav-tab" role="tablist">
                      <div className="tabList">
                        {tabData.map((tab, index) => {
                          let disCls = tab.disable;
                          return tab.show ? (
                            <a
                              className={`nav-item nav-link active`}
                              id={tab.id}
                              name={index}
                              data-toggle="tab"
                              role="tab"
                              aria-controls="nav-details"
                              aria-selected="true"
                            >
                              {tab.name}
                            </a>
                          ) : (
                            ""
                          );
                        })}
                      </div>
                    </div>
                  </nav>
                  <div className="tabContent">
                    <Form className="form defaultForm">
                      <Loader loading={loading} overlay={overlay}>
                        {tab.details ? (
                          <Row>
                            <Col md={12}>
                              <Row>
                                <Col md={12}>
                                  <Row>
                                    <Col md={2}>
                                      <Form.Label>Title Name *</Form.Label>
                                    </Col>
                                    <Col md={8}>
                                      <Form.Control
                                        type="text"
                                        name="name"
                                        value={form.name}
                                        onChange={(e) =>
                                          handleInput("name", e.target.value)
                                        }
                                        isInvalid={!!errors.description}
                                      />
                                      <Form.Control.Feedback type="invalid">
                                        {errors.name}
                                      </Form.Control.Feedback>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col md={2}>
                                      <Form.Label>Description *</Form.Label>
                                    </Col>
                                    <Col md={8}>
                                      <Form.Control
                                        type="text"
                                        as="textarea"
                                        name="description"
                                        style={{ minHeight: "500px" }}
                                        value={form.description}
                                        onChange={(e) =>
                                          handleInput(
                                            "description",
                                            e.target.value
                                          )
                                        }
                                        isInvalid={!!errors.description}
                                      />
                                      <Form.Control.Feedback type="invalid">
                                        {errors.description}
                                      </Form.Control.Feedback>
                                    </Col>
                                  </Row>

                                  <Row>
                                    <Col md={2}>
                                      <Form.Label>Image *</Form.Label>
                                    </Col>
                                    <Col md={8}>
                                      <Form.Control
                                        type="file"
                                        name="image"
                                        onChange={(e) =>
                                          handleInput(
                                            "image",
                                            e.target.files[0]
                                          )
                                        }
                                        isInvalid={!!errors.image}
                                      />
                                      <Form.Control.Feedback type="invalid">
                                        {errors.image}
                                      </Form.Control.Feedback>
                                    </Col>
                                  </Row>

                                  <Row>
                                    <Col md={2}></Col>
                                    {file ? (
                                      <Col>
                                        <img
                                          src={file}
                                          style={{
                                            maxWidth: "200px",
                                            maxHeight: "100px",
                                          }}
                                          alt="img"
                                        />
                                      </Col>
                                    ) : (
                                      <Col>
                                        <img
                                          src={
                                            form.image
                                              ? config.service.replace(
                                                  "/api",
                                                  ""
                                                ) + form.image
                                              : logo
                                          }
                                          style={{
                                            maxWidth: "200px",
                                            maxHeight: "100px",
                                          }}
                                          alt="img"
                                        />
                                      </Col>
                                    )}
                                  </Row>

                                  <Row>
                                    <Col md={2}>
                                      <Form.Label>Link *</Form.Label>
                                    </Col>
                                    <Col md={8}>
                                      <Form.Control
                                        type="text"
                                        name="link"
                                        value={form.link}
                                        onChange={(e) =>
                                          handleInput("link", e.target.value)
                                        }
                                        isInvalid={!!errors.link}
                                      />
                                      <Form.Control.Feedback type="invalid">
                                        {errors.link}
                                      </Form.Control.Feedback>
                                    </Col>
                                  </Row>

                                  <Row>
                                    <Col md={2}>
                                      <Form.Label>Blog *</Form.Label>
                                    </Col>
                                    <Col md={8}>
                                      <Select
                                        className={`selectBox ${
                                          !!errors.blogpost
                                            ? "inValidField"
                                            : ""
                                        }`}
                                        value={blogpost}
                                        onChange={(e) =>
                                          handleSelect(
                                            "blog_id",
                                            setBlogPost,
                                            e
                                          )
                                        }
                                        options={blogpostList}
                                        isClearable
                                      />

                                      {errors.blog_id ? (
                                        <Form.Control.Feedback
                                          type="invalid"
                                          className="d-block"
                                        >
                                          {errors.blog_id}
                                        </Form.Control.Feedback>
                                      ) : (
                                        ""
                                      )}
                                    </Col>
                                  </Row>

                                  {/* <Row>
                                                <Col md={4}>
                                                    <Form.Label>State</Form.Label>
                                                </Col>
                                                <Col md={7}>
                                                  <Form.Control disabled type='text' name="state" value={state} />
                                                <Select className={`selectBox ${!! errors.state  ? 'inValidField' : ''}`}
                                                    value={state}
                                                    onChange={e=>handleSelect('state',setState,e)}
                                                    options={stateList}
                                                    isClearable
                                                />
                                                </Col>
                                            </Row> */}
                                  {/* <Row>
                                                <Col md={2}>
                                                    <Form.Label>Active</Form.Label>
                                                </Col>
                                                <Col md={2}>
                                                <Form.Check 
                                                        type="switch"
                                                        id="custom-switch"
                                                        label=""
                                                        onChange={e=>handleInput('active',(e.target.checked))}
                                                        checked = {form.active === true ? true : false}
                                                      />
                                                  </Col>
                                              </Row> */}
                                  {/* <Form.Control disabled type='text' name="state" value={state} /> */}
                                  {/* <Select className={`selectBox ${!! errors.state  ? 'inValidField' : ''}`}
                                                    value={state}
                                                    onChange={e=>handleSelect('state',setState,e)}
                                                    options={stateList}
                                                    isClearable
                                                /> */}
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        ) : (
                          ""
                        )}
                      </Loader>
                    </Form>
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </Container>
  );
};

export default PostForm;
